import {
    getExam,
    getExamList,
    getExamByPost
} from "../../api/service.js"
import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";
import http from "../../api/module";
import fa from "element-ui/src/locale/lang/fa";
import pagination from "@/components/pagination";
import VDistpicker from "v-distpicker";
import number from "less/lib/less/functions/number";
let that;


if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
    // Firefox 38+ seems having support of enumerateDevicesx
    navigator.enumerateDevices = function (callback) {
        navigator.mediaDevices.enumerateDevices().then(callback);
    };
}
var MediaDevices = [];
var isHTTPs = location.protocol === 'https:';
var canEnumerate = false;

if (typeof MediaStreamTrack !== 'undefined' && 'getSources' in MediaStreamTrack) {
    canEnumerate = true;
} else if (navigator.mediaDevices && !!navigator.mediaDevices.enumerateDevices) {
    canEnumerate = true;
}

var hasMicrophone = false;
var hasSpeakers = false;
var hasWebcam = false;

var isMicrophoneAlreadyCaptured = false;
var isWebcamAlreadyCaptured = false;

export default {
    components: {
        HeadCom,
        FooterCom,
        pagination,
        VDistpicker,
    },
    data() {
        return {
            userInfo: {},
            paramObj: {
                exerciseType: "",
                catePatentId: "",
                cateId: ""
            },
            dataForm: {
                entpName: '',
                affiliatedEnterprise: '',
                postId: '',
                regCertificateNum: '',
                annualType: '',
                regCertificateDate: '',
                entpId: ''
            },
            followingTeaching: [],
            courseCatetoryPatentList: [],
            courseCatetorySubsetList: [],
            exerciseList: [],
            dataSure: false,
            courseIds: '',
            isLogin: false,
            pageSize: 50,
            total: 0,
            pageNum: 1,
            examTypeList: [{
                name: "全部",
                value: "",
                isActive: true
            }, {
                name: "模拟考试",
                value: "0"
            }, {
                name: "练习题库",
                value: "1"
            }],
            isJx: false,
            examListHeight: {
                height: window.innerHeight - 130 + 'px'
            },
            imgHeight: {
                height: window.innerHeight - 260 + 'px'
            },
            institutionsList: [],
            rules: {
                postId: [{
                    required: true,
                    message: "请选择专业",
                    trigger: "change"
                }],
                regCertificateNum: [{
                    required: true,
                    message: "请输入证书编号",
                    trigger: "blur"
                }],
                annualType: [{
                    required: true,
                    message: "请选择继教年度",
                    trigger: "change"
                }],
                regCertificateDate: [{
                    required: true,
                    message: "请选择证书发证时间",
                    trigger: "blur"
                }],
                affiliatedEnterprise: [{
                    required: true,
                    message: "请输入企业名称",
                    trigger: "blur"
                }],
                regOldPost: [{
                    required: true,
                    message: "请选择学历名称",
                    trigger: "change"
                }]

            },
            chooseDialog: false,
            chooseForm: {},
            select: {
                province: "湖北省",
                city: ""
            },
            loading: false,
            organList: [],
            currentPage: 1, // 当前页
            limit: 10, // 每页显示数量
            total: 0, // 总条目数
            educationOptions: [{
                    value: '中职(含技工学校)',
                    label: '中职(含技工学校)'
                },
                {
                    value: '专科(含高职和技师学院)',
                    label: '专科(含高职和技师学院)'
                },
                {
                    value: '本科及以上',
                    label: '本科及以上'
                }
            ],
        }
    },
    created() {
        this.getUserInfo();
        that = this;
        if (localStorage.getItem("enterpriseId")) {
            that.isLogin = true;
        }
        that.paramObj.exerciseType = that.$route.query.type;
        that.examTypeList.forEach(function (bObj) {
            that.$set(bObj, 'isActive', false);
            bObj.isActive = false;
            if (that.$route.query.type === bObj.value) {
                bObj.isActive = true;
            }
        });
        this.getSelectAnnualType();
    },
    open: {
        handler(val, oldVal) {
            if (this.open == true && this.formCertificate.examType) {
                let params = {
                    examType: this.formCertificate.examType,
                };
                // 获取职务下拉框
                getJobListByExamType(params).then((response) => {
                    this.jobOptions = response.data;
                });
            } else {
                this.jobOptions = [];
            }

            if (this.open == true && this.title == "新增证书添加申请") {
                this.reset();
                if (
                    this.formCertificate.examType == "" ||
                    this.formCertificate.examType == undefined
                ) {
                    this.formCertificate.job = "";
                }
            }
        },
    },
    watch: {
        'dataForm.entpId': {
            handler(val, oldVal) {
                if (val && oldVal == '') {
                    http.getSpecial({
                            entpId: val,
                        })
                        .then((data) => {
                            if (data.data.success == true) {
                                this.institutionsList = data.data.data;
                            } else {
                                this.$message.error({
                                    duration: 1000,
                                    message: data.data.message,
                                });
                            }
                        })
                        .catch((error) => {
                            this.$message.error({
                                duration: 1000,
                                message: "请求失败,请联系管理员!",
                            });
                        });
                } else if (val != oldVal && oldVal != '') {
                    this.dataForm.postId = null
                    http.getSpecial({
                            entpId: oldVal,
                        })
                        .then((data) => {
                            console.log('dsadsa', data)
                            if (data.data.success == true) {
                                this.institutionsList = data.data.data;
                            } else {
                                this.$message.error({
                                    duration: 1000,
                                    message: data.data.message,
                                });
                            }
                        })
                        .catch((error) => {
                            this.$message.error({
                                duration: 1000,
                                message: "请求失败,请联系管理员!",
                            });
                        });
                } else {
                    this.institutionsList = [];
                }
            },
        },
    },
    methods: {
        change() {
            this.$forceUpdate();
        },
        // 选择机构
        selectInstitutions() {
            this.chooseDialog = true
        },
        // 选择培训机构搜索
        getOrganList() {
            this.loading = true;
            this.select.province =
                this.select.province == "省" ? "" : this.select.province;
            this.select.city = this.select.city == "市" ? "" : this.select.city;
            http
                .getEnter({
                    pageNum: this.currentPage,
                    pageSize: this.limit,
                    entpName: this.chooseForm.name,
                    agentProvince: this.select.province, // 省
                    agentCity: this.select.city, // 市
                })
                .then((data) => {
                    if (data.data.code == "200" || data.data.success == true) {
                        this.loading = false;
                        this.organList = data.data.data;
                        this.total = data.data.total;
                    } else {
                        this.$message.error({
                            duration: 1000,
                            message: data.data.message,
                        });
                    }
                })
                .catch((error) => {
                    this.$message.error({
                        duration: 1000,
                        message: "请求失败,请联系管理员!",
                    });
                });
        },
        // 省市
        selected(data) {
            this.select.province = data.province.value;
            this.select.city = data.city.value;
        },
        // 选择省
        onChangeProvince(data) {
            this.select.province = data.value;
        },
        // 选择市
        onChangeCity(data) {
            this.select.city = data.value;
        },
        // 选择区
        onChangeArea(data) {
            console.log(data);
            this.select.area = data.value;
        },
        selectBtn() {
            this.currentPage = 1;
            this.$refs.page.init();
            this.getOrganList();
        },
        // 当前页
        handleCurrentChange(val) {
            console.log(val);
            this.currentPage = val;
            this.getOrganList();
        },
        // 每页数
        handleSizeChange(val) {
            this.limit = val;
            this.currentPage = 1;
            this.getOrganList();
        },
        // 确认选择
        chooseBtn() {
            if (this.dataForm.entpId) {
                this.chooseDialog = false;
                http.getSpecial({
                        entpId: this.dataForm.entpId,
                    })
                    .then((data) => {
                        if (data.data.success == true) {
                            this.institutionsList = data.data.data;
                        } else {
                            this.$message.error({
                                duration: 1000,
                                message: data.data.message,
                            });
                            this.institutionsList = []

                        }
                    })
                    .catch((error) => {
                        this.$message.error({
                            duration: 1000,
                            message: "请求失败,请联系管理员!",
                        });
                    });
            } else {
                this.$message.warning({
                    duration: 1000,
                    message: "请选择培训机构!",
                });
                this.institutionsList = ''
            }
        },
        rowClick(row, column, event) {
            console.log(row, "row");
            this.dataForm.entpId = row.entpId;
            this.dataForm.entpName = row.entpName;
        },
        /* 弹框表单清空 */
        resetForm() {
            this.chooseForm = {};
            this.select.city = "";
        },
        // 填写报名信息
        regInformation(formName) {
            console.log('11', this.dataForm.entpName)
            if (this.dataForm.entpName == undefined || this.dataForm.entpName == '' || this.dataForm.entpName == null) {
                this.$message.warning({
                    duration: 1000,
                    message: "请选择培训机构!",
                });
                return false
            } else {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        http.addRegistrationForEmp({
                                affiliatedEnterprise: this.dataForm.affiliatedEnterprise || "",
                                regCertificateNum: this.dataForm.regCertificateNum || "",
                                regCertificateDate: this.dataForm.regCertificateDate || "",
                                regBatch: this.dataForm.batchId || "",
                                entpId: this.dataForm.entpId,
                                affiliatedEnterprise: this.dataForm.affiliatedEnterprise,
                                postId: this.dataForm.postId,
                                regCertificateNum: this.dataForm.regCertificateNum,
                                annualType: this.dataForm.annualType,
                                regCertificateDate: this.dataForm.regCertificateDate,
                                regSex: this.userInfo.empSex,
                                regTel: this.userInfo.empTel || "",
                                regHeadPortrait: this.userInfo.empHeadportrait,
                                regName: this.userInfo.empName,
                                regIdcard: this.userInfo.empIdcard,
                                regCategory: this.userInfo.empCategory,
                                regOldPost: this.dataForm.regOldPost,
                            })
                            .then(data => {
                                if (data.data.success == true) {
                                    this.$message.success({
                                        duration: 1000,
                                        message: "报名成功"
                                    });
                                    this.dataForm.entpId = ''
                                    this.dataForm.entpName = ''
                                    this.$refs[formName].resetFields();
                                    this.getUserInfo();
                                } else {
                                    // this.$message.error({
                                    //     duration: 1000,
                                    //     message: data.data.message
                                    // });
                                    this.$alert(data.data.message, '提示', {
                                        confirmButtonText: '确定',
                                        callback: action => {}
                                    });
                                }
                            })
                            .catch(error => {
                                this.$message.error({
                                    duration: 1000,
                                    message: "请求失败，请联系管理员！"
                                });
                            });
                    } else {
                        return false;
                    }
                });
            }
        },
        //获取用户信息
        getUserInfo() {
            http.getUserInfo().then(data => {
                if (data.data.code == '200' || data.data.success == true) {
                    this.userInfo = data.data.data;
                } else {
                    this.$message.error({
                        duration: 1000,
                        message: data.data.message
                    })
                }
            }).catch(error => {

            })
        },
        cancel(formName) {
            this.$refs[formName].resetFields();
            this.dataForm.entpName = undefined
            this.institutionsList = []
        },
        // 获取继续教育年度数据
        getSelectAnnualType() {
            http.selectAnnualType().then(res => {
                if (res.data.code) {
                    this.followingTeaching = res.data.data;
                }
            });
        }
    }
}